module.exports = __webpack_public_path__ + "img/ridhaf.7b26f993.jpg";